/* eslint-disable no-use-before-define */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unused-state */
import React, { Component } from 'react';
// import { reportError } from '../../services/api/ReportErrorApi';
import { ErrorSvg } from '../../asset/svgs/ErrorSvg';
import { Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

class ExceptionHandleError extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorMessage: '',
    };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      errorMessage: error.toString()
    };
  }

  //   componentDidCatch(error, errorInfo) {
  //     this.sendErrorToAPI(error, errorInfo);
  //   }

  //   sendErrorToAPI = async (error, errorInfo) => {
  //     const payload = {
  //       ErrorDetails: `${error} ${errorInfo.componentStack}`,
  //     };

  //     try {
  //       await reportError(payload);
  //     } catch (err) {
  //       console.error(err);
  //     }
  //   }

  render() {
    if (this.state.hasError) {
      return (
        <>
          <div style={styles.errorContainer}>
            <ErrorSvg />
            <strong style={{ fontSize: '20px' }}>
              Oops! Something went wrong.
            </strong>

            <p>
              We&lsquo;re sorry for the inconvenience. Please try refreshing the page,
              or click the button below to go back to the homepage.
            </p>

            <Button
              color="primary"
              component={RouterLink}
              to="/"
              variant="outlined"
            >
              Back to Home
            </Button>
          </div>
        </>

      );
    }
    return this.props.children;
  }
}

const styles = {
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#FFFFFF',
    color: '#333333',
    padding: '20px',
    textAlign: 'center',
    fontFamily: 'Arial, sans-serif',
  },
  svgContainer: {
    marginBottom: '40px',
    width: '250px',
    height: '250px',
  },
  errorMessage: {
    fontSize: '36px',
    fontWeight: 'bold',
    marginBottom: '20px',
    color: '#333333',
  }
};

export default ExceptionHandleError;
